/* istanbul ignore file */

import { createContext, useContext } from 'react'
import { EppoClient } from '@eppo/js-client-sdk-common'

export const EppoContext = createContext<EppoClient | null>(null)

export const useEppoClient = () => useContext(EppoContext)
